import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import address from './address';
import app from '../slices/app';
import emailVerification from './emailVerification';
import lead from './lead'; // use alias
import properties from './properties';
import user from '../slices/user';
import payment from './payment';
import env from './env';
import userManagement from './userManagement';
import singleFamilyEnterprise from './singleFamilyEnterprise';
import relist from './relist';
import rentGuarantee from './rentGuarantee';
import submitRequest from './submitRequest';
import devTool from './devTool';

const rootReducer = (...args: Parameters<typeof connectRouter>) =>
  combineReducers({
    address,
    app,
    env,
    emailVerification,
    singleFamilyEnterprise,
    lead,
    properties,
    payment,
    user,
    userManagement,
    relist,
    rentGuarantee,
    router: connectRouter(...args),
    submitRequest,
    devTool,
  });

export type State = ReturnType<ReturnType<typeof rootReducer>>;

export default rootReducer;
